import BuildContent from "./BuildContent"

export default BuildContent
